import * as React from 'react';
import chariotDafPayIconImage from './chariotDafPayIconImage.js';

function ChariotDafPayCheckedIcon(props) {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                fill="#ffffff"
                fillOpacity="1"
                stroke="none"
                cx="14"
                cy="14"
                r="14"
            />
            <image
                width="26"
                height="26"
                preserveAspectRatio="none"
                href={chariotDafPayIconImage}
                x="1"
                y="1"
            />
        </svg>
    );
}

export default ChariotDafPayCheckedIcon;
